import Component from '@glimmer/component';

interface UiInputGroupNativeSelectOptionSignature {
  Element: HTMLOptionElement;
  Blocks: {
    default: [];
  };
}

export default class UiInputGroupNativeSelectOptionComponent extends Component<UiInputGroupNativeSelectOptionSignature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::InputGroup::NativeSelect::Option': typeof UiInputGroupNativeSelectOptionComponent;
    'ui/input-group/native-select/option': typeof UiInputGroupNativeSelectOptionComponent;
  }
}
